<template>
  <div id="app">
    <div class="d-flex justify-center mx-2 mt-15 w-100" fluid>
      <v-card class="px-2 w-50">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <v-form @submit.prevent="handleSubmit(submitForm)">
            <v-row>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pb-0">
                <p class="app-title-small text-sm ma-0">
                  Job Grade Code
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Job Grade Code"
                  rules="required"
                >
                  <v-text-field
                    v-model="jobGradeCode"
                    :error-messages="errors"
                    single-line
                    dense
                    disabled
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-0">
                <p class="app-title-small text-sm ma-0">
                  Job Grade Name
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Job Grade Name"
                  rules="required"
                >
                  <v-text-field
                    v-model="jobGradeName"
                    :error-messages="errors"
                    single-line
                    dense
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-0">
                <p class="app-title-small text-sm ma-0">
                  Job Grade Category
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Job Grade Category"
                  rules="required"
                >
                  <v-text-field
                    v-model="jobGradeCategory"
                    :error-messages="errors"
                    single-line
                    dense
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-2">
                <v-btn
                  type="submit"
                  color="#7b7a7a"
                  class="text-center ma-1"
                  width="100%"
                  dark
                  :loading="loading"
                  small
                >
                  <span class="text-capitalize">Update</span>
                </v-btn>
                <v-btn
                  color="#008ef8"
                  @click.prevent="closeSuccessNavigate"
                  class="text-center ma-1"
                  width="100%"
                  dark
                  text
                  small
                >
                  <span class="text-capitalize">Cancel</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-card>
      <!-- dialog success -->
      <v-dialog v-model="dialog" persistent max-width="350">
        <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
          <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
          <v-card-title class="title-card mx-auto text-center"
            >Update Job Grade<br />Success</v-card-title
          >
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="closeSuccessNavigate"
              color="green"
              :loading="loading"
              class="mt-3 w-full"
              width="100%"
              dark
            >
              <span class="text-capitalize">Okay</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog failed -->
      <v-dialog v-model="dialog2" persistent max-width="350">
        <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
          <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
          <v-card-title class="title-card mx-auto text-center"
            >Update Job Grade<br />Failed</v-card-title
          >
          <p class="mx-auto">The Code already exists</p>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="dialog2 = false"
              color="green"
              class="mt-3 w-full"
              width="100%"
              dark
            >
              <span class="text-capitalize">Okay</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { createNamespacedHelpers } from "vuex";
const karyawan = createNamespacedHelpers("masterKaryawan");
export default {
  data() {
    return {
      tab: null,
      dates: [],
      jobGradeCode: null,
      jobGradeName: null,
      jobGradeCategory: null,
      dialog2: false,
      dialog: false,
      errorMessage: null,
      loading: false,
      e1: 1
    };
  },
  watch: {
    res_jobgrade(newval) {
      this.jobGradeCode = newval.grade_code;
      this.jobGradeName = newval.grade_name;
      this.jobGradeCategory = newval.grade_category;
    }
  },
  computed: {
    ...karyawan.mapState(["res_jobgrade"])
  },
  components: {},
  mounted() {
    this.$store.commit("masterKaryawan/SET_IDJOBGRADE", this.$route.params.id);
    this.$store.dispatch("masterKaryawan/getMasterGradeById");
  },
  methods: {
    onTagValueChange(e) {
      this.employeeName = e.employee_name;
      this.posisition = e.posisition;
    },
    closeSuccessNavigate() {
      this.dialog = false;
      setTimeout(() => {
        this.$router.push("/master-job-grade/");
      }, 200);
    },
    submitForm() {
      const temp_user = JSON.parse(Cookies.get("userdata_login"));
      // button effect
      this.loading = true;
      this.formInput = {
        grade_code: this.jobGradeCode,
        grade_name: this.jobGradeName,
        grade_category: this.jobGradeCategory,
        id_create: temp_user.data.id
      };
      this.$store.commit(
        "masterKaryawan/SET_IDJOBGRADE",
        this.$route.params.id
      );
      this.$store.commit("masterKaryawan/SET_TEMPJOBGRADE", this.formInput);
      this.$store
        .dispatch("masterKaryawan/updateGrade")
        .then(response => {
          const res = response.data;
          if (res.status) {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.status.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.theme--dark.v-icon {
  color: #000000;
}
.theme--dark.v-icon.v-icon.v-icon--disabled {
  color: rgb(2 2 2 / 31%) !important;
}
</style>
